import { GroupButton } from "../../components/GroupButton";
import { ITimesheet } from "../models/timesheetModels";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { exportToFile } from "../../utils/functionUtils";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import { toast } from "react-toastify";
import { EXPORT_FILE_NAME, RESPONSE_STATUS_CODE, SEARCH_OBJECT_MAX_SIZE, TYPE_REF, VARIABLE_STRING } from "../../constants/moduleConsts";
import AppContext from "../../../AppContext";
import { Col, Row } from "react-bootstrap";
import TextValidator from "../../components/input/text-validator";
import { KTSVG } from "../../../../_metronic/helpers";
import TableTimesheetOvertime from "./TableTimesheetOvertime";
import { searchTimeSheetOvertime } from "../services/timesheetServices";
import { exportTimeSheetOvertime } from "../../services/exportFileServices";
import DialogPrintTimeKeepingOvertime from "./DialogPrintTimeKeepingOvertime";
import { LIST_ATTRIBUTION_OVERTIME } from "../constants/timesheetConsts";

export interface IPropsTimesheetForm {
    timesheetInfo: ITimesheet;
    handleClose: () => void;
    handleCloseAndSearch: () => void;
}

const TimesheetOvertimeForm = (props: IPropsTimesheetForm) => {
    const { timesheetInfo, handleClose, handleCloseAndSearch } = props;
    const { lang } = useMultiLanguage();
    const { setPageLoading } = useContext(AppContext);
    const refsArray = useRef<any[]>([]);


    const [isView, setIsView] = useState<boolean>(true);
    const [isShowSymbol, setIsShowSymbol] = useState<boolean>(false);
    const [initDataTable, setInitDataTable] = useState<any[]>([]);
    const [openDialogPrint, setOpenDialogPrint] = useState<any>({
        open: false,
        dataSearchPrint: null
    });

    useEffect(() => {
        handleSearch();
    }, []);

    const handleSearch = async () => {
        try {
            setPageLoading(true);
            let { phongBanId, nam, thang } = timesheetInfo;
            let searchObject = {
                ...SEARCH_OBJECT_MAX_SIZE,
                nam,
                thang,
                phongBanId
            };

            const { data } = await searchTimeSheetOvertime(searchObject);
            if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
                setInitDataTable(data?.data?.content || [])
                setIsView(true);
                return;
            }
            toast.warning(data?.message);
        } catch (error) {
            toast.error(lang("GENERAL.ERROR"));
        } finally {
            setPageLoading(false);
        }
    };

    const handleExportExcel = () => {
        if (!initDataTable.length) {
            toast.warning(lang("GENERAL.NO_DATA_TO_EXPORT"));
            return;
        }

        let { donViCongTacCode, donViCongTacText, phongBanId, phongBanText, nam, thang } = timesheetInfo;
        let searchObject = {
            ...SEARCH_OBJECT_MAX_SIZE,
            nam,
            thang,
            phongBanId,
            phongBanText,
            orgCode: donViCongTacCode,
            orgText: donViCongTacText,
        };
        exportToFile({
            exportAPI: () => exportTimeSheetOvertime(searchObject),
            fileName: `${EXPORT_FILE_NAME.BANG_CHAM_CONG_THEM_GIO}${thang ? " tháng " + thang
                : ""}${nam ? " năm " + nam : ""}`,
            setPageLoading
        });
    }

    const setRefsArray = useCallback((index: any, key: any, typeRef: string = TYPE_REF.INPUT_REF, id: string) => (element: any) => {
        let newElement = element ? element : {}
        newElement.typeRef = typeRef;
        newElement.id = id;
        refsArray.current[index] = refsArray.current[index] || {};
        refsArray.current[index][key] = newElement;
    }, []);

    return (
        <div>
            <div className="header-form-action">
                <GroupButton type="btn-back" handleClose={handleClose} />
                <div className="flex gap-4"></div>
            </div>
            <div className="form-content-scroll">
                <Row className="g-3 pt-3">
                    <Col xs={12} sm={6} md={5} lg={4} xl={3} xxl={3}>
                        <TextValidator
                            readOnly
                            lable={lang("GENERAL.CURRENT_ORGANIZATION")}
                            value={timesheetInfo?.donViCongTacText || ""}
                            name={VARIABLE_STRING.DON_VI_CONG_TAC}
                        />
                    </Col>
                    <Col xs={12} sm={6} md={5} lg={4} xl={3} xxl={3}>
                        <TextValidator
                            readOnly
                            lable={lang("INPUT.DEPARTMENTS")}
                            value={timesheetInfo?.phongBanText || ""}
                            name={VARIABLE_STRING.PHONG_BAN}
                        />
                    </Col>
                    <Col xs={6} sm={3} md={2} lg={2} xl={1} xxl={1}>
                        <TextValidator
                            readOnly
                            lable={lang("GENERAL.YEAR")}
                            value={String(timesheetInfo?.nam) || ""}
                            name={VARIABLE_STRING.YEAR}
                            valueSearch="name"
                        />
                    </Col>
                    <Col xs={6} sm={3} md={2} lg={2} xl={1} xxl={1}>
                        <TextValidator
                            readOnly
                            lable={lang("GENERAL.MONTH")}
                            value={timesheetInfo?.thang || ""}
                            name={VARIABLE_STRING.MONTH}
                            valueSearch="code"
                        />
                    </Col>
                    <Col xs={6} sm={3} md={3} lg={2} xl={2} xxl={2}>
                        <TextValidator
                            readOnly
                            lable={lang("GENERAL.STATUS")}
                            value={timesheetInfo?.trangThai?.name || ""}
                            name="trangThai"
                        />
                    </Col>
                    <Col xs={6} sm={3} md={3} lg={2} xl={2}>
                        <TextValidator
                            readOnly
                            name="ngayDuyet"
                            lable={lang("DATE.APPROVE")}
                            type="date"
                            value={timesheetInfo?.ngayDuyet || ""}
                        />
                    </Col>
                    <Col sm={6} md={4} lg={4} xl={3} xxl={3}>
                        <TextValidator
                            readOnly
                            lable={lang("WELFARE.ACTUAL_COST.APPROVED_PEOPLE")}
                            value={timesheetInfo?.nguoiDuyetText || ""}
                            name="nguoiDuyet"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className={!isShowSymbol ? "show-full" : ""}>
                        <div className="relative pt-2 mb-3">
                            <p className='fw-bold text-uppercase fs-1 text-center m-0'>bảng chấm công thêm giờ</p>
                            <p className='fw-bold fs-4 text-center m-0'>{`Tháng ${timesheetInfo.thang ?? "....."} năm ${timesheetInfo.nam ?? "....."}`}</p>
                            {isView && (
                                <div className="position-absolute bottom-0 end-0 d-flex spaces gap-2">
                                    <GroupButton handleEvent={() => setOpenDialogPrint((prev: any) => {
                                        return {
                                            ...prev,
                                            open: true
                                        }
                                    })}>
                                        {lang("BTN.PRINT")}
                                    </GroupButton>
                                    <GroupButton outline handleEvent={handleExportExcel}>
                                        <KTSVG path="/media/icons/export-excel.svg" />{" "}
                                        {lang("BTN.EXPORT")}
                                    </GroupButton>
                                </div>
                            )}
                        </div>
                        <TableTimesheetOvertime
                            data={[...initDataTable]}
                            dateSearch={timesheetInfo}
                            dataKHChamCong={[]}
                            isView={isView}
                            refsArray={refsArray}
                            setRefsArray={setRefsArray}
                        />
                    </Col>
                </Row>
            </div>
            {openDialogPrint.open &&
                <DialogPrintTimeKeepingOvertime
                    open={openDialogPrint}
                    dateSearch={openDialogPrint.dataSearchPrint || { ...SEARCH_OBJECT_MAX_SIZE, ...timesheetInfo }}
                    listAttribution={LIST_ATTRIBUTION_OVERTIME}
                    handleClose={() => setOpenDialogPrint({
                        open: false,
                        dataSearchPrint: null
                    })}
                />
            }
        </div>
    )
};

export default TimesheetOvertimeForm;